/* ============
 * All Transaction Types
 * ============
 *
 * All transaction types.
 */

import Vue from 'vue';
import store from './../../store';
import transactionTypeTransformer from './../../transformers/transactionType';

const success = ({ data }, resolve) => {
  const types = transactionTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllTransactionTypes', types);
  resolve();
};

const failed = () => {};

// Display transaction types.
export default () => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.get('transaction_types')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/transactionType/all.js